import React from "react";
import AppRouter from "router";
import "bootstrap/dist/css/bootstrap.min.css";

const App: React.FC = () => {
  return <AppRouter />;
};

export default App;
